import React from 'react';
import styled from 'styled-components';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';

import { primaryColor } from '~theme';

import { Spinner } from '~ui-kit';

const OrderWindow = ({ order, height }) => (
  <Wrapper>
    {order && order.presentables ? (
      <Window forceVisible="y" autoHide={false} height={height || '100px'}>
        <Table>
          <TableBody>
            {order.presentables.map(({ label, value }) => (
              <Row key={label}>
                <Label>{label}</Label>
                <Value>{value}</Value>
              </Row>
            ))}
          </TableBody>
        </Table>
      </Window>
    ) : (
      <Spinner />
    )}
  </Wrapper>
);

const Wrapper = styled.div`
  font-size: 16px;
`;

const Window = styled(SimpleBar)`
  border: 1px solid #707070;
  border-radius: 4px;
  background-color: white;

  max-height: ${props => props.height};

  // Scrollbar stuff
  .simplebar-track.simplebar-vertical {
    width: 18px;
    background-color: white;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .simplebar-scrollbar::before {
    background-color: ${primaryColor};
    opacity: 255;
    left: 4px;
    right: 4px;
  }

  .simplebar-track.simplebar-vertical .simplebar-scrollbar::before {
    top: 4px;
    bottom: 4px;
  }
`;

const Table = styled.table`
  min-height: 60px;
  max-height: 120px;
  font-size: 14px;
  color: #707070;
  margin: 2px; // Required to make the content not leak outside the rounded corners *shrug*
`;

const TableBody = styled.tbody`
  & > :nth-child(2n) {
    background-color: #f7f7f7;
  }
`;

const Row = styled.tr``;

const Label = styled.td`
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  white-space: nowrap;
`;

const Value = styled.td`
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  width: 100%;
`;

export default OrderWindow;
